import { DashboardDataProvider } from './DashboardDataContext';
import { DashboardUIProvider } from './DashboardUIContext';

const DashboardProviderWrapper = ({ children, dataAdapters }) => (
  <DashboardDataProvider dataAdapters={dataAdapters}>
    <DashboardUIProvider>{children}</DashboardUIProvider>
  </DashboardDataProvider>
);

export default DashboardProviderWrapper;
